module.exports = __webpack_public_path__ + "img/img6.518c672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img6.png
// module id = 181
// module chunks = 0